import { useQuery } from "@tanstack/react-query";

import { Sdk } from "~/lib/graphql/client";

function useShortAccountContent(client: Sdk) {
  return useQuery({
    queryKey: ["meShortAccountContent"],
    queryFn: () => client.meShortAccountContent(),
  });
}

function usePointReportContent(client: Sdk) {
  return useQuery({
    queryKey: ["mePointReport"],
    queryFn: () => client.mePointReport(),
  });
}

function useMeQuestTaskContent(client: Sdk) {
  return useQuery({
    queryKey: ["meQuestTaskContent"],
    queryFn: () => client.meQuestTaskContent(),
  });
}

function useMeCommittedDatabase(client: Sdk) {
  return useQuery({
    queryKey: ["meCommittedDatabase"],
    queryFn: () => client.meCommittedDatabase(),
  });
}

function useMeQuestContent(client: Sdk) {
  return useQuery({
    queryKey: ["meQuestContent"],
    queryFn: () => client.meQuestContent(),
  });
}

function useMeFussyAttestationContent(client: Sdk) {
  return useQuery({
    queryKey: ["meFussyAttestationContent"],
    queryFn: () => client.meFussyAttestationContent(),
  });
}

function useRadioResponseMemoryContent(client: Sdk) {
  return useQuery({
    queryKey: ["meRadioResponseMemoryContent"],
    queryFn: () => client.meRadioResponseMemoryContent(),
  });
}

function useMeMembershipShortcutContent(client: Sdk) {
  return useQuery({
    queryKey: ["meMembershipShortcutContent"],
    queryFn: () => client.meMembershipShortcutContent(),
  });
}

function useMeExamHistory(client: Sdk) {
  return useQuery({
    queryKey: ["meExamHistory"],
    queryFn: () => client.meExamHistory(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 1000 * 60 * 5,
  });
}

/**
 * @package
 */
export {
  useShortAccountContent,
  usePointReportContent,
  useMeQuestTaskContent,
  useMeCommittedDatabase,
  useMeQuestContent,
  useMeFussyAttestationContent,
  useRadioResponseMemoryContent,
  useMeMembershipShortcutContent,
  useMeExamHistory,
};
